import request from '@/utils/request'

const giftApiList = [
  // 获取待办
  ['getUpComingList', 'POST', '/api/exp/hecexptodo', 'data'],
  // 获取已办
  ['getCompleteList', 'POST', '/api/exp/hecexpvolved', 'data'],
  // 获取待办详情
  ['getExpDetails', 'POST', '/api/exp/custom/ecReport', 'data'],
  // 审批
  ['handleDoNext', 'POST', '/api/exp/exec/hecexpaction', 'data'],
  // 获取审批记录
  ['loadExpRecord', 'POST', '/api/exp/hecexpspls', 'data']
]

// 获取费用明细全部数据
export const getCuxhecexplinesinfo = data => {
  return request({
    method: "POST",
    url: "/api/exp/cuxhecexplinesinfo",
    data
  });
};
// 获取修改的发票信息
export const getInvoiceInfo = data => {
  return request({
    method: "POST",
    url: "/api/exp/cuxhecexplinesmi",
    data
  });
};



let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum
  sum[prev[0]] = prev
  return sum
}, {})

export function fetchData (apiName, payload) {
  const api = apiListMap[apiName]
  let options
  if (api[4] === 'replace' && payload) {
    options = {
      url: api[2].replace('{id}', payload),
      method: api[1]
    }
  } else {
    options = {
      url: api[2],
      method: api[1]
    }
  }
  if (api[1] === 'GET' && api[4] !== 'replace' && payload) {
    options.params = payload
  }
  if (api[1] === 'POST' && payload) {
    if (api[3] !== 'params') {
      options.data = payload
    } else {
      options.params = payload
    }
  }
  return request(options)
}
